// /home/w3d/web3reg-com/src/components/DemoTweet.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faComment, 
  faRetweet, 
  faHeart, 
  faChartLine, 
  faBook, 
  faShare, 
  faPlay 
} from '@fortawesome/free-solid-svg-icons';

const DemoTweet = () => {
  const demoUser = {
    ensName: 'john.zpost.eth',
    displayName: 'John',
    avatarLetter: 'J',
    bio: 'First member of Zpost. Building the future of free speech.'
  };

  const demoTweet = {
    content: "Just claimed my identity on Zpost. This is what free speech feels like. No middlemen, no algorithms. Just my voice and my .zpost.eth domain. #FreeSpeech #Web3",
    timestamp: '2 hours ago',
    likeCount: 124,
    repostCount: 42,
    replyCount: 18,
    impressionCount: 1250,
    bookmarkCount: 56,
    isVerified: true
  };

  return (
    <div className="demo-tweet-container" style={{ 
      position: 'relative',
      padding: '0'
    }}>
      {/* Glowing effect around the tweet */}
      <div style={{
        position: 'absolute',
        top: '-10px',
        left: '0',
        right: '0',
        height: 'calc(100% + 20px)',
        background: 'linear-gradient(45deg, var(--gold) 0%, transparent 50%)',
        borderRadius: '15px',
        opacity: '0.15',
        zIndex: 0,
        pointerEvents: 'none'
      }}></div>
      
      <div className="zpost-tweet card"
           style={{ 
             position: 'relative',
             zIndex: 1,
             textDecoration: 'none', 
             color: 'inherit',
             marginBottom: '0',
             transition: 'box-shadow 0.3s ease, transform 0.2s ease',
             border: '2px solid var(--gold)',
             background: 'var(--card-bg)',
             overflow: 'hidden',
             width: '100%',
           }}
           onMouseEnter={(e) => {
             e.currentTarget.style.boxShadow = '0 8px 25px var(--gold-shadow-hover)';
             e.currentTarget.style.transform = 'translateY(-5px)';
           }}
           onMouseLeave={(e) => {
             e.currentTarget.style.boxShadow = '0 4px 12px var(--gold-shadow)';
             e.currentTarget.style.transform = 'translateY(0)';
           }}>
        
        {/* "Live Example" badge */}
        <div style={{
          position: 'absolute',
          top: '15px',
          right: '15px',
          background: 'var(--dark-red)',
          color: 'var(--gold)',
          padding: '5px 15px',
          borderRadius: '20px',
          fontSize: '0.8rem',
          fontWeight: 'bold',
          border: '1px solid var(--gold)',
          zIndex: 2,
          boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
        }}>
          LIVE EXAMPLE
        </div>

        {/* Tweet Header */}
        <div className="zpost-tweet-header" style={{ 
          position: 'relative', 
          zIndex: 1,
          display: 'flex',
          padding: '1.5rem 1.5rem 0 1.5rem',
          gap: '1rem',
          alignItems: 'flex-start'
        }}>
          <div className="zpost-tweet-avatar" style={{ position: 'relative', flexShrink: 0 }}>
            <div style={{
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              backgroundColor: 'var(--dark-red)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--gold)',
              fontWeight: 'bold',
              fontSize: '1.8rem',
              border: '3px solid var(--gold)',
              boxShadow: '0 0 15px var(--gold-shadow)'
            }}>
              {demoUser.avatarLetter}
            </div>
            {demoTweet.isVerified && (
              <div style={{
                position: 'absolute',
                bottom: '0',
                right: '0',
                background: 'var(--gold)',
                color: 'black',
                borderRadius: '50%',
                width: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.7rem',
                border: '2px solid var(--dark-red)'
              }}>
                ✓
              </div>
            )}
          </div>
          <div className="zpost-tweet-author" style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
              <h3 style={{ 
                color: 'var(--text-light)', 
                margin: 0, 
                fontSize: '1.3rem',
                fontWeight: 'bold'
              }}>
                {demoUser.displayName}
              </h3>
              {demoTweet.isVerified && (
                <span style={{ 
                  color: 'var(--gold)', 
                  fontSize: '0.8rem',
                  background: 'rgba(255, 215, 0, 0.1)',
                  padding: '2px 8px',
                  borderRadius: '10px',
                  border: '1px solid var(--gold)'
                }}>
                  Verified
                </span>
              )}
            </div>
            <p className="eth-label" style={{ 
              color: 'var(--gold)', 
              margin: '0 0 0.5rem 0',
              fontSize: '1.1rem',
              fontWeight: 'bold',
              textShadow: '0 0 5px var(--gold-shadow)'
            }}>
              @{demoUser.ensName}
            </p>
            <p style={{ 
              color: 'var(--text-secondary)', 
              fontSize: '0.9rem',
              margin: '0',
              fontStyle: 'italic'
            }}>
              {demoUser.bio}
            </p>
          </div>
          <span style={{ 
            color: 'var(--text-secondary)', 
            fontSize: '0.9rem',
            fontWeight: 'bold',
            flexShrink: 0,
            marginTop: '0.25rem'
          }}>
            {demoTweet.timestamp}
          </span>
        </div>

        {/* Tweet Content */}
        <div className="zpost-tweet-content" style={{ 
          marginTop: '1rem', 
          position: 'relative', 
          zIndex: 1,
          padding: '0 1.5rem'
        }}>
          <p style={{ 
            fontSize: '1.2rem', 
            lineHeight: '1.6',
            color: 'var(--text-light)',
            marginBottom: '1rem'
          }}>
            {demoTweet.content}
          </p>
          
          {/* Video Section */}
          <div style={{
            marginTop: '1rem',
            borderRadius: '16px',
            overflow: 'hidden',
            border: '1px solid var(--border)',
            position: 'relative',
            width: '100%',
            height: '0',
            paddingBottom: '56.25%', /* 16:9 aspect ratio */
            backgroundColor: 'rgba(0, 0, 0, 0.1)'
          }}>
            <video
              src="/john.mp4"
              style={{
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block'
              }}
              controls
              muted
              loop
              autoPlay
              playsInline
              preload="auto"
              poster=""
            >
              Your browser does not support the video tag.
            </video>
            
            {/* Autoplay indicator */}
            <div style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              background: 'rgba(0, 0, 0, 0.7)',
              color: 'var(--gold)',
              padding: '4px 8px',
              borderRadius: '12px',
              fontSize: '0.7rem',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              border: '1px solid var(--gold)',
              zIndex: 2
            }}>
              <FontAwesomeIcon icon={faPlay} style={{ fontSize: '0.6rem' }} />
              Autoplay
            </div>
          </div>
          
          {/* Hashtags */}
          <div style={{ 
            display: 'flex', 
            gap: '0.5rem', 
            marginTop: '1rem',
            flexWrap: 'wrap'
          }}>
            <span style={{
              background: 'rgba(255, 215, 0, 0.1)',
              color: 'var(--gold)',
              padding: '4px 12px',
              borderRadius: '20px',
              fontSize: '0.85rem',
              border: '1px solid var(--gold-shadow)'
            }}>
              #FreeSpeech
            </span>
            <span style={{
              background: 'rgba(255, 215, 0, 0.1)',
              color: 'var(--gold)',
              padding: '4px 12px',
              borderRadius: '20px',
              fontSize: '0.85rem',
              border: '1px solid var(--gold-shadow)'
            }}>
              #Web3
            </span>
            <span style={{
              background: 'rgba(255, 215, 0, 0.1)',
              color: 'var(--gold)',
              padding: '4px 12px',
              borderRadius: '20px',
              fontSize: '0.85rem',
              border: '1px solid var(--gold-shadow)'
            }}>
              #Zpost
            </span>
          </div>
        </div>

        {/* Tweet Stats */}
        <div className="zpost-tweet-actions" style={{ 
          marginTop: '1.5rem',
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          justifyContent: 'space-between',
          borderTop: '1px solid var(--border)',
          padding: '1rem 1.5rem',
          flexWrap: 'wrap',
          gap: '0.5rem 0'
        }}>
          {/* Replies */}
          <div className="zpost-tweet-action" style={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'default',
            minWidth: '80px',
            flex: '1'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <FontAwesomeIcon icon={faComment} style={{ color: 'var(--gold)' }} />
              <span style={{ 
                color: 'var(--text-light)', 
                fontWeight: 'bold',
                fontSize: '1.1rem'
              }}>
                {demoTweet.replyCount}
              </span>
            </div>
            <span style={{ 
              color: 'var(--text-secondary)', 
              fontSize: '0.8rem',
              marginTop: '0.2rem'
            }}>
              Replies
            </span>
          </div>
          
          {/* Reposts */}
          <div className="zpost-tweet-action" style={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'default',
            minWidth: '80px',
            flex: '1'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <FontAwesomeIcon icon={faRetweet} style={{ color: 'var(--gold)' }} />
              <span style={{ 
                color: 'var(--text-light)', 
                fontWeight: 'bold',
                fontSize: '1.1rem'
              }}>
                {demoTweet.repostCount}
              </span>
            </div>
            <span style={{ 
              color: 'var(--text-secondary)', 
              fontSize: '0.8rem',
              marginTop: '0.2rem'
            }}>
              Reposts
            </span>
          </div>
          
          {/* Likes */}
          <div className="zpost-tweet-action" style={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'default',
            minWidth: '80px',
            flex: '1'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <FontAwesomeIcon icon={faHeart} style={{ color: 'var(--gold)' }} />
              <span style={{ 
                color: 'var(--text-light)', 
                fontWeight: 'bold',
                fontSize: '1.1rem'
              }}>
                {demoTweet.likeCount}
              </span>
            </div>
            <span style={{ 
              color: 'var(--text-secondary)', 
              fontSize: '0.8rem',
              marginTop: '0.2rem'
            }}>
              Likes
            </span>
          </div>
          
          {/* Impressions */}
          <div className="zpost-tweet-action" style={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'default',
            minWidth: '80px',
            flex: '1'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <FontAwesomeIcon icon={faChartLine} style={{ color: 'var(--gold)' }} />
              <span style={{ 
                color: 'var(--text-light)', 
                fontWeight: 'bold',
                fontSize: '1.1rem'
              }}>
                {demoTweet.impressionCount > 999 ? 
                  `${(demoTweet.impressionCount / 1000).toFixed(1)}k` : 
                  demoTweet.impressionCount}
              </span>
            </div>
            <span style={{ 
              color: 'var(--text-secondary)', 
              fontSize: '0.8rem',
              marginTop: '0.2rem'
            }}>
              Views
            </span>
          </div>
          
          {/* Bookmarks */}
          <div className="zpost-tweet-action" style={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'default',
            minWidth: '80px',
            flex: '1'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <FontAwesomeIcon icon={faBook} style={{ color: 'var(--gold)' }} />
              <span style={{ 
                color: 'var(--text-light)', 
                fontWeight: 'bold',
                fontSize: '1.1rem'
              }}>
                {demoTweet.bookmarkCount}
              </span>
            </div>
            <span style={{ 
              color: 'var(--text-secondary)', 
              fontSize: '0.8rem',
              marginTop: '0.2rem'
            }}>
              Bookmarks
            </span>
          </div>
          
          {/* Share */}
          <div className="zpost-tweet-action" style={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'default',
            minWidth: '80px',
            flex: '1'
          }}>
            <FontAwesomeIcon icon={faShare} style={{ color: 'var(--gold)' }} />
            <span style={{ 
              color: 'var(--text-secondary)', 
              fontSize: '0.8rem',
              marginTop: '0.2rem'
            }}>
              Share
            </span>
          </div>
        </div>
      </div>
      
      {/* Caption below the tweet */}
      <div style={{
        textAlign: 'center',
        color: 'var(--text-secondary)',
        marginTop: '1.5rem',
        fontSize: '0.9rem',
        fontStyle: 'italic',
        margin: '1.5rem auto 0',
        padding: '1rem',
        background: 'rgba(255, 215, 0, 0.05)',
        borderRadius: '10px',
        border: '1px dashed var(--gold-shadow)'
      }}>
        <strong>This is what your Zpost will look like.</strong> Your .zpost.eth domain becomes your verified identity. 
        Join John and be part of the free speech revolution.
      </div>
    </div>
  );
};

export default DemoTweet;
